import axios from "axios";
import secureLocalStorage from "react-secure-storage";
// Get Employee Shift Hours Report
export const get_employee_shift_hours_report= async (filterPayload) => {
    let response = await axios.post(`${secureLocalStorage.getItem("baseURL")}/api/get-employee-shift-report/`,filterPayload);
    return response.data;
}